import { useNavigate } from 'react-router-dom-latest';
import { AppBar, Button, Stack, Typography } from '@common-components';
import { UserRole } from 'enums';
import { useCurrentUser, useSetEndUser } from 'hooks';
import { messages } from 'i18n';
import { BROKER_ROUTES } from 'broker/broker-routes';

export const EndUserIndicator = () => {
  const { me, endUser } = useCurrentUser();
  const navigate = useNavigate();

  const { isFetching: isClearing, refetch: clearEndUser } = useSetEndUser();

  const onClear = async () => {
    if (me?.role === UserRole.BackOffice) {
      navigate(BROKER_ROUTES.BACK_OFFICE, { state: { shouldClearEndUser: true } });
    } else {
      await clearEndUser();
      // redirect to the home page
      navigate(BROKER_ROUTES.SUBMISSION_BOX);
    }
  };

  if (me?.role === UserRole.CapitolaBroker && endUser?.role !== UserRole.Retailer) {
    return null;
  }

  return (
    <AppBar
      position="sticky"
      sx={{
        border: 1,
        borderColor: '#f72585',
        bgcolor: '#ffb9d3ed',
        alignItems: 'center',
        pl: 1,
        zIndex: 1500,
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Stack direction="row" gap={1} alignItems="center">
        <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.875rem', lineHeight: 1 }}>
          {messages.endUserIndicator.indicatorText(
            me?.endUser
              ? {
                  firstName: me.endUser.firstName,
                  lastName: me.endUser.lastName,
                  company: me.endUser.organization.name,
                }
              : undefined,
          )}
        </Typography>
        {me?.endUser && (
          <Button onClick={onClear} loading={isClearing} size="small">
            {me?.role === UserRole.CapitolaBroker
              ? messages.endUserIndicator.signOutCapitolaBroker
              : messages.endUserIndicator.signOutBackoffice}
          </Button>
        )}
      </Stack>
    </AppBar>
  );
};
